import constants from './constants';

export const initialState = {
  data: [],
  error: null,
  pcpDetailsLoading: false,
  pcpDetailsError: null,
  storedValue: null,
};

export const pcpDetailsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case constants.SET_VALUE:
      return {
        ...state,
        storedValue: payload,
      };
      case constants.SET_CLEANUP:
        return initialState;

    case constants.SET_PCP_DETAILS_BEGIN: {
      return {
        ...state,
        pcpDetailsLoading: true,
        pcpDetailsError: null
      };
    }
   
    case constants.SET_PCP_CLEANUP:
      return initialState;

    case constants.SET_PCP_DETAILS_SUCCESS: {
      return {
        ...state,
        data: [...state.data, payload],
        pcpDetailsLoading: false,
        pcpDetailsError: null
      };
    }
    case constants.SET_PCP_ERROR: {
      return {
        ...state,
        pcpDetailsLoading: false,
        pcpDetailsError: payload.error
      };
    }
    default:
      return state;
  }
};